import countriesList from "./countries-list.json";
import { unique } from "../unique";

export interface Country {
  id: string;
  country: string;
  geoRegion: string;
}

export const countries: readonly Country[] = Object.freeze(
  [...countriesList].sort((a, b) => a.country.localeCompare(b.country)),
);

export const geoRegions: readonly string[] = Object.freeze(
  unique(countriesList.map((it) => it.geoRegion)).sort((a, b) => a.localeCompare(b)),
);

export const countryIdsByName: Readonly<Record<string, string>> = Object.freeze(
  countries.reduce<Record<string, string>>(
    (obj, { id, country }) => {
      obj[country] = id;
      obj[id] = id; // to deal with code that might already have id...
      return obj;
    },
    {},
  ),
);

export const countryNameByID: Readonly<Record<string, string>> = Object.freeze(
  countries.reduce<Record<string, string>>(
    (obj, { id, country }) => {
      obj[id] = country;
      obj[country] = country; // to deal with code that might already have name...
      return obj;
    },
    {},
  ),
);

export const geoRegionByCountry: Readonly<Record<string, string>> = Object.freeze(
  countries.reduce<Record<string, string>>(
    (obj, { id, geoRegion }) => {
      obj[id] = geoRegion;
      return obj;
    },
    {},
  ),
);

export const geoRegionByCountryNameOrId: Readonly<Record<string, string>> = Object.freeze(
  countries.reduce<Record<string, string>>(
    (obj, { id, country, geoRegion }) => {
      obj[country] = geoRegion;
      obj[id] = geoRegion;
      return obj;
    },
    {},
  ),
);
